import { render } from "./SvgArrow.vue?vue&type=template&id=d5162178&scoped=true"
import script from "./SvgArrow.vue?vue&type=script&lang=js"
export * from "./SvgArrow.vue?vue&type=script&lang=js"

import "./SvgArrow.vue?vue&type=style&index=0&id=d5162178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5162178"]])

export default __exports__